export default __webpack_public_path__ + "static/media/pen.4de46a1c.svg";